module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-send-to-external-service"
  }, [_c('reveal', {
    attrs: {
      "confirm": true
    },
    on: {
      "confirm": _vm.sendToSDI
    }
  }, [_c('h2', [_vm._v("Sei sicuro?")]), (_vm.invoice.extra.hasOwnProperty('einvoice')) ? _c('div', {
    staticClass: "status"
  }, [_c('h2', [_vm._v("Ultimi status")]), _vm._l((_vm.invoice.extra.einvoice.results), function(result) {
    return _c('div', {
      staticClass: "results"
    }, [_c('div', [_vm._v("File name: " + _vm._s(result.uploadFileName))]), _c('div', [_vm._v("Result: " + _vm._s(result.errorCode) + " - " + _vm._s(result.errorDescription))]), _c('div', [_vm._v("Date: " + _vm._s(result.created_at))])])
  })], 2) : _vm._e(), _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Invia a SDI")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e46c39c2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/modules/einvoice/SendToExternalService.vue
// module id = 2739
// module chunks = 1